<template>
  <div class="nav-left social-nav">
    <a v-for="(link, i) in socialLinks" class="nav-item" :href="link.url" target="_blank" rel="noopener noreferrer" :key="i">
      <span class="icon">
        <iconify-icon :icon="link.icon"></iconify-icon>
        <span class="sr-only">{{ link.name }}</span>
      </span>
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SubscribeModule',
  data () {
    return {
      socialLinks: [
        {
          name: 'Apple Podcasts',
          icon: 'ph:apple-podcasts-logo-fill',
          url: 'https://itunes.apple.com/us/podcast/the-longest-shortest-time/id412457621?mt=2'
        },
        {
          name: 'Spotify',
          icon: 'mdi:spotify',
          url: 'https://open.spotify.com/show/7sfcXmCcDIsdd1uvYOIQGp?si=dadbc012c74446b2'
        },
        {
          name: 'Overcast',
          icon: 'simple-icons:overcast',
          url: 'https://overcast.fm/itunes412457621'
        },
        {
          name: 'RSS',
          icon: 'material-symbols:rss-feed',
          url: 'https://feeds.megaphone.fm/QCD4231325211'
        },
        {
          name: 'Facebook',
          icon: 'mdi:facebook',
          url: 'https://www.facebook.com/longestshortesttime'
        },
        {
          name: 'Instagram',
          icon: 'mdi:instagram',
          url: 'https://www.instagram.com/longestshortesttime/'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'socialLinks'
    ])
  }
}
</script>

<style lang="sass" scoped>
@import ../../assets/styles/colors
@import ../../assets/styles/mixins

.nav-left
  margin-right: 20px
  flex: initial
  overflow: visible
  +tablet
    .nav-item
      padding: 0.5rem
  +smDesktop
    display: flex
    .nav-item
  +desktop
    margin-right: 0
    padding: 0.5rem 0.75rem

.social-nav
  .nav-item
    flex: none
    border-top: none
    padding: 0.25em 0 0.75em
    +tablet
      padding: 0.5em
    +desktop
      padding: 0.75em
    .icon
      border: 1px solid rgba(65, 64, 66, 0.2)
      width: 36px
      height: 36px
      border-radius: 50%
      font-size: 24px
      line-height: 1
      padding: 5px
      svg
        width: 100%
        height: auto
    &:hover
      .icon
        border: 1px solid rgba(65, 64, 66, 0.5)
      svg
        *
          fill: #414042
</style>



// WEBPACK FOOTER //
// SubscribeModule.vue?6a4c6104